import React, { useState } from 'react'
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { forgotPassword } from '../../Services/AuthServices';

const useForgot = () => {

    const [email, setEmail] = useState();
    const [isLoading, setIsLoading] = useState();

    const handleEmail = (e) => { setEmail(e.target.value) }
    const navigate = useNavigate()

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsLoading(true)
        let response = await forgotPassword({ email })
        if (response.statusCode === 200) {
            toast?.success(response?.message)
            setIsLoading(false)
            navigate("/otp")

            localStorage.setItem('forgot_email', email);

        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)
    }
    return [
        email,
        isLoading,
        handleEmail,
        handleSubmit,
    ]
}

export default useForgot